module.exports = __webpack_public_path__ + "img/img7.c27c11a9.png";